import React, { useState, useEffect, useReducer } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {  Row, Col, Spinner } from "react-bootstrap";
import Header from "./components/Header";
import Friends from "./components/Friends";
import Content from "./components/Content";
import VKcontext from "./context/VKcontext";
import PhotoViewer from "./components/PhotoViewer";
import AuthService from "./components/authService";
import { friendsState, friendsReducer } from "./store/friendsReducer";

function App() {
  
  const [active, setActive] = useState();
  const [modalShow, setModalShow] = React.useState(false);
  const [image, setImage] = useState("");
  const [token, setToken] = useState("");
  const [state, dispatch] = useReducer(friendsReducer, friendsState );

  
  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, []);
  return (
    <VKcontext.Provider
      value={{ active, setActive, setImage, setModalShow, token, setToken, state, dispatch }}
    >
        {token ? (
          
          <Row className='content-row'>
            <Col xs={12}>
              <Header />
            </Col>
            <Col xs={2}>
              <Friends />
            </Col>
            <Col className="d-flex flex-wrap" xs={10}>
              <Content />
              <PhotoViewer
                show={modalShow}
                image={image}
                onHide={() => setModalShow(false)}
              />
            </Col>
          </Row>

        ) : (
          <AuthService />
        )}
    </VKcontext.Provider>
  );
}

export default App;
